const messages = {
  loginTitle: 'Having Issues Logging In?',
  registerTitle: 'Having Issues Creating an Account?',
  list: {
    createdAnAccountPreviously: {
      title: 'Have you created an account previously?',
      description:
        'You cannot register a new account if one already exists. Use the Forgot Password function on the Portal home screen to reset your existing account’s password.',
    },
    receivedInvitation: {
      title: 'Have you received an invitation already to join Portal?',
      description:
        'A representative for our property may have already sent you an invitation via email. Check your inbox (including your Spam folder) for any Portal invitations received from our property. In the body of the email, you will be able to select the option to “Claim Your Account," which will enable you to log in to your new account.',
    },
    unsubscribedFromEmails: {
      title: 'Have you unsubscribed from our emails previously?',
      description:
        'We will need to resubscribe you to our emails in order to receive the Portal invitation to log in. Contact the office and let us know that you need to resubscribe to emails from our property.',
    },
    changedEmailAddress: {
      title: 'Have you changed your email address on file with us?',
      description:
        'Your email address may have been updated in our system, which would be tied to your Portal account. Ensure the email address you are trying to log in with is the one you provided to our property.',
    },
    accountDeactivated: {
      title: 'Has your account been deactivated?',
      description:
        'If you are receiving an error message stating that your account has been deactivated, you are prevented from logging into your account. Contact the office for more assistance.',
    },
    tooManyLoginAttempts: {
      title: 'Have you tried to log in too many times?',
      description:
        'If you have tried to log in unsuccessfully more than the permitted number of times, you will need to contact our property so that someone can reset your account for you.',
    },
  },
};

export default messages;
